import { post, getPublic, postPublic } from './APIHelper';

export const getPackages = async () => {
  return getPublic('packages');
};

export const createCheckoutSession = async payload => {
  return post('stripe/create-checkout-session', payload);
};

export const createPublicCheckoutSession = async payload => {
  return postPublic('stripe/create-checkout-session-public', payload);
};

export const getCheckoutSessionConversion = async sessionId => {
  return getPublic(`stripe/checkout-session/${encodeURIComponent(sessionId)}/conversion`);
};
